// extracted by mini-css-extract-plugin
export default {"SwipeLeftToClose":"beo_a bhj_bk bhj_bl bhj_bo","SwipeLeftToClose--animating":"beo_b"};